import React from "react"
import { JSX } from "react"
import { Navigate } from "react-router-dom"
import { jwtDecode } from "jwt-decode"
import { API_ROUTES } from "../configuration/RoutesApi"
import { PATH_MAP } from "../configuration/PathMap"

type JwtPayload = {
  exp?: number
  IsAdmin?: string
  AdminEmployee_Id?: string
}

const AdminOnlyRoute: React.FC<{ children: JSX.Element }> = ({ children }) => {
  const [nowInSeconds] = React.useState(() => Date.now() / 1000)

  const token = localStorage.getItem(API_ROUTES.TOKEN_ADMIN)

  if (!token) {
    return <Navigate to={PATH_MAP.ADMIN_LOGIN_PAGE} replace />
  }

  let canAccessAdminPanel = false

  try {
    const rawToken = token.replace(/['"]/g, "")

    const decoded = jwtDecode<JwtPayload>(rawToken)

    const isRootAdmin = decoded.IsAdmin === "True"

    const isAdminEmployee = Boolean(decoded.AdminEmployee_Id)

    canAccessAdminPanel = Boolean(decoded.exp) && decoded.exp >= nowInSeconds && (isRootAdmin || isAdminEmployee)

    if (!canAccessAdminPanel) {
      localStorage.removeItem(API_ROUTES.TOKEN_ADMIN)
    }
  } catch {
    localStorage.removeItem(API_ROUTES.TOKEN_ADMIN)
  }

  return canAccessAdminPanel ? children : <Navigate to={PATH_MAP.ADMIN_LOGIN_PAGE} replace />
}

export default AdminOnlyRoute
